import { ChainId } from '../constant';
import { Client } from './type';

const exchangeGraph = process.env.REACT_APP_EXCHANGE_GRAPH;
const onePieceServer = process.env.REACT_APP_ONE_PIECE_SERVER_GRAPHQL_ENDPOINT;
const distributor = process.env.REACT_APP_DISTRIBUTOR_GRAPHQL_ENDPOINT;

export default {
    [ChainId.mainnet]: {
        [Client.exchangeSubgraph]: exchangeGraph || '',
        [Client.onePieceServer]: onePieceServer || '',
        [Client.distributor]: distributor || '',
    },
    [ChainId.testnet]: {
        [Client.exchangeSubgraph]: exchangeGraph || '',
        [Client.onePieceServer]: onePieceServer || '',
        [Client.distributor]: distributor || '',
    },
};
